<template>
  <div class="notification">
    <v-card flat="flat" class="nuclear">
      <v-card-title class="nuclear-title"
        >All Notifications</v-card-title
      >
      <v-card-text>
        <v-row v-for="item in notification_items" :key="item.id">
          <v-col cols="12" sm="6" md="6" lg="4">
            <div class="notification_item">
              <font-awesome-icon class="alert-bell" icon="bell" />
              <p class="description">{{ item.notification }}</p>

              <router-link
                :to="{
                  name: 'report',
                  params: { id: item.upload_details.uploadId }
                }"
                v-if="item.upload_details.file_type == 'analysis'"
                style="text-decoration: none;"
              >
                <v-btn class="view">
                  <span>View</span>
                </v-btn>
              </router-link>              

              <v-dialog
                v-model="enumerationDialog"
                persistent
                max-width="850px"
                v-if="item.upload_details.file_type == 'enumeration'"
              >
                <template v-slot:activator="{ on }">
                  <v-btn class="view" v-on="on" @click="enumerationViewClicked(item)">
                    <span>View</span>
                  </v-btn>
                </template>
                <v-card>
                  <v-card-title class="justify-center">
                    <span class="headline">Building Data</span>
                  </v-card-title>
                  <v-card-text class="justify-center">
                    <div
                      v-if="mapLoading == true"
                      style="margin-left: 45%; margin-top: 50px; margin-bottom: 50px;"
                    >
                      <v-progress-circular
                        :size="70"
                        :width="7"
                        color="teal"
                        indeterminate
                      ></v-progress-circular>
                    </div>

                    <gmap-map
                      v-else
                      :center="center"
                      :zoom="11"
                      style="width:100%;  height: 70vh"
                    >
                      <gmap-marker
                        :key="index"
                        v-for="(m, index) in mapMarkers"
                        :position="m.position"
                        @click="center = m.position"
                        :clickable="true"
                        :draggable="true"
                      ></gmap-marker>
                    </gmap-map>
                  </v-card-text>
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                      class="cancel"
                      text
                      @click="enumerationDialog = false"
                      >Close</v-btn
                    >
                  </v-card-actions>
                </v-card>
              </v-dialog>
            </div>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </div>
</template>
<script>
export default {
  data() {
    return {
      enumerationDialog: false,
      center: { lat: 34.052235, lng: -118.243683 }
    };
  },
  mounted() {
    const data = {
      all: true
    };
    this.$store.dispatch("getAllNotification", data);
  },
  methods: {
    enumerationViewClicked(item) {
      const data = {
        notification_id: item.upload_details.id
        // limit: 500,
        // page: 1
      };
      this.$store.dispatch("getMarkers", data);
    }
  },
  computed: {
    notification_items() {
      return this.$store.state.notification.all;
    },

    mapLoading() {
      return this.$store.state.notification.mapLoading;
    },

    mapMarkers() {
      return this.$store.state.notification.mapMarkers;
    }
  }
};
</script>
